import React from 'react';
import { Link } from 'react-router-dom';
import AlertMessage from './AlertMessage';

export interface SuccessMessageProps {
  message: string;
  linkText: string;
  linkTo: string;
}

/**
 * Reusable success message component matching the ForgotPasswordPage style.
 * Displays a success alert with a link below it.
 */
const SuccessMessage: React.FC<SuccessMessageProps> = ({ message, linkText, linkTo }) => {
  return (
    <div className="text-center">
      <AlertMessage type="success" message={message} />
      <div className="mt-4">
        <Link
          to={linkTo}
          className="text-green-600 hover:text-green-500 font-medium"
        >
          {linkText}
        </Link>
      </div>
    </div>
  );
};

export default SuccessMessage;

